module.exports = __webpack_public_path__ + "media/images/mv1_copy-4ba29e3eec38e8c804d0745d273e2c3b.png";